import React from 'react';

const LoadingAnim = () => {
  return (
    <div className="loadingAnim">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default LoadingAnim;
